import React from 'react';
import { Box, Paper, SxProps, Theme, Typography } from '@mui/material';
import QueryBuilderRoundedIcon from '@mui/icons-material/QueryBuilderRounded';

import { buttonSizeSx, secondaryButtonSx } from 'theme/buttons';

export const DECISION_SX = {
  ...buttonSizeSx.md,
  ...secondaryButtonSx,
} as const;

export const BarNote: React.FC<{
  icon?: boolean;
  children: React.ReactNode;
}> = ({ icon, children }) => (
  <Box display="flex" alignItems="center" gap={0.75} color="text.secondary">
    {icon && <QueryBuilderRoundedIcon sx={{ fontSize: 16 }} />}
    <Typography variant="body1" color="text.secondary">
      {children}
    </Typography>
  </Box>
);

export const ActionBar: React.FC<{
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}> = ({ sx, children }) => (
  <Paper
    sx={[
      (theme) => ({
        px: 3,
        py: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        flexWrap: { sm: 'wrap' },
        alignItems: { sm: 'center' },
        gap: 1,
        borderRadius: 0,
        borderTop: `1px solid ${theme.palette.background.divider}`,
        boxShadow: 'none',
        '& > *': { width: { xs: '100%', sm: 'auto' } },
      }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Paper>
);
